import {Route, BrowserRouter, Routes,} from "react-router-dom";
import Manutencao from "../Pages/Manutencao";

const Rotas = () => {
    return(
        
        <BrowserRouter>
            <Routes>
                <Route element = {<Manutencao/>} path="/"/>
            </Routes>
        </BrowserRouter>
        
    )
}

export default Rotas;